import React from "react";
import BaseNode from "../../base/BaseNode";

const SendMessageEvolutionNode = ({ data, selected }) => {
  const config = data.config || {};
  const content = config.content || "";
  const phone = config.phone || "";

  let subtitle = "Não configurado";

  if (phone && content) {
    const displayContent = content.length > 25 ? content.substring(0, 25) + "..." : content;
    subtitle = `${phone.substring(0, 13)}... - ${displayContent}`;
  } else if (phone) {
    subtitle = phone;
  } else if (content) {
    subtitle = content.length > 30 ? content.substring(0, 30) + "..." : content;
  }

  return (
    <BaseNode
      data={data}
      icon="bi-whatsapp"
      color="#25D366"
      label="Evolution - Send"
      subtitle={subtitle}
      hasHandles={{ top: true, bottom: true }}
      selected={selected}
    />
  );
};

export default SendMessageEvolutionNode;